<template>
  <div class="scanner-container">
    <div id="reader" class="qr-reader"></div>
    <div class="result" v-if="scannedContent">
      <p>Scanned content: 
        <a v-if="scannedContent.startsWith('http')" :href="scannedContent" target="_blank" rel="noopener noreferrer">{{ scannedContent }}</a>
        <span v-else>{{ scannedContent }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
  data() {
    return {
      scannedContent: null,
      html5QrCode: null,
    };
  },
  mounted() {
    this.html5QrCode = new Html5Qrcode("reader");
    this.startScanner();
  },
  beforeUnmount() {
    if (this.html5QrCode) {
      this.html5QrCode.stop().then(() => {
        console.log("QR Code scanning stopped.");
      }).catch(err => {
        console.error("Failed to stop scanning: ", err);
      });
    }
  },
  methods: {
    startScanner() {
      this.html5QrCode.start(
        { facingMode: "environment" },
        {
          fps: 10,
          qrbox: undefined,
        },
        (decodedText) => {
          this.scannedContent = decodedText;
          
          // Extrahiere die stationId aus der URL
          const urlParams = new URLSearchParams(decodedText.split('?')[1]);
          const stationId = urlParams.get('id');
          
          if (stationId && this.isValidStationId(stationId)) {
            this.updateStationStatus(stationId);
            this.redirectToChecklist();
          } else {
            console.log("Ungültige Station oder kein QR-Code erkannt.");
          }
        }
      ).catch(err => {
        console.error("Unable to start scanning: ", err);
      });
    },
    isValidStationId(stationId) {
      const validStationIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // Deine validen Stationen
      return validStationIds.includes(parseInt(stationId));
    },
    updateStationStatus(stationId) {
      let stations = JSON.parse(localStorage.getItem('stations')) || [
        { id: 1, name: 'BW/UNCO/OMAI/WINF', completed: false },
        { id: 2, name: 'International Business', completed: false },
        { id: 3, name: 'digBiz-HAK', completed: false },
        { id: 4, name: 'Marketing & Sales', completed: false },
        { id: 5, name: 'Betriebswirtschaftliches Zentrum', completed: false },
        { id: 6, name: 'Handelsschule', completed: false },
        { id: 7, name: 'Erasmus+', completed: false },
        { id: 8, name: 'Bewegung und Sport', completed: false },
        { id: 9, name: 'Lebende Fremdsprachen', completed: false },
        { id: 10, name: 'Naturwissenschaften', completed: false },
        { id: 11, name: 'Bibliothek', completed: false },
        { id: 12, name: 'Abend HAK', completed: false },
      ];

      // Update der Station
      const stationIndex = stations.findIndex(station => station.id === parseInt(stationId));
      if (stationIndex !== -1) {
        stations[stationIndex].completed = true;
        localStorage.setItem('stations', JSON.stringify(stations)); // Speichern der aktualisierten Stationen
      }
    },
    redirectToChecklist() {
      // Weiterleitung zur Checkliste-Seite
      this.$router.push({ name: 'ChecklistPage' });
    }
  }
};
</script>

<style scoped>
/* Dein Style bleibt unverändert */
</style>


<style scoped>
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.scanner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 8px;
  background-color: #f8f9fa;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.qr-reader {
  width: 100%;
  max-width: 400px;
  height: auto;
  border: 2px solid #98c1d9;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.qr-reader video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: none !important;
  z-index: 1;
}

.qr-reader::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
  border: 4px solid white;
  pointer-events: none;
  z-index: 2;
}

.result {
  margin-top: 10px;
  text-align: center;
  color: #343a40;
}

.result a {
  color: #007bff;
  text-decoration: none;
}

.result a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .scanner-container {
    padding: 4px;
  }

  .qr-reader {
    max-width: 90vw;
    height: 60vw;
  }

  .result {
    margin-top: 5px;
  }
}
</style>
